import { withInstall } from "../utils/index.mjs";
import _Image from "./Image.mjs";
const Image = withInstall(_Image);
var stdin_default = Image;
export {
  Image,
  stdin_default as default
};
